define("ember-changeset-validations/utils/with-defaults", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = withDefaults;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * Create a new object with defaults
   *
   * @public
   * @param  {Object} obj
   * @param  {Object} defaults
   * @return {Object}
   */
  function withDefaults() {
    let obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.assign(Object.assign({}, defaults), obj);
  }
});